import testseriesGif from "../../Videos/TestSeries.webm";
import videocoursesGif from "../../Videos/VideoCourses.webm";
import studymaterialsGif from "../../Videos/StudyMaterials.webm";
import booksGif from "../../Videos/Books.webm";
import onlineliveclassesGif from "../../Videos/OnlineLiveClasses.webm";
import onlineliveclassesSvg from "../../image/preprationvector/OnlineLiveClasses.svg";
import onlineliveclassesSvg2 from "../../image/preprationvector/OnlineLiveClasses2.svg";
import testseriesSvg from "../../image/preprationvector/TestSeries.svg";
import videocoursesSvg from "../../image/preprationvector/VideoCourses.svg";
import videocoursesSvg2 from "../../image/preprationvector/videocoursesSvg2.svg";
import studymaterialsSvg from "../../image/preprationvector/StudyMaterials.svg";
import booksSvg from "../../image/preprationvector/Books.svg";

const Data = [
  {
    id: 1,
    style: "bgimage1",
    // cardimage: onlineliveclassesGif,
    cardsvg: onlineliveclassesSvg2,
    cardheading: "Quizzes",
    carddiscription:
      "Challenge yourself with topic-wise quizzes and instant results",
    btntext: "Explore Live Classes",
    to:"/quizzes",
  },
  {
    id: 2,
    style: "bgimage2",
    cardimage: testseriesGif,
    cardsvg: testseriesSvg,
    cardheading: "Test Series",
    carddiscription:
      "Elevate Your Preparation, Dive into Realistic Exam Scenarios",
    btntext: "Explore Test Series",
    to:"/testseries",
  },
  {
    id: 3,
    style: "bgimage1",
    // cardimage: videocoursesGif,
    cardsvg: videocoursesSvg2,
    cardheading: "Previous Year Paper",
    carddiscription:
      "Solve previous year papers and analyze your performance",
    btntext: "Explore Videos",
    to:"/previousyearpapers",
  },
  // {
  //   id: 4,
  //   style: "bgimage2",
  //   cardimage: studymaterialsGif,
  //   cardsvg: studymaterialsSvg,
  //   cardheading: "Study Materials",
  //   carddiscription: "Unlock Your Learning Potential with Our Study Materials",
  //   btntext: "Explore Notes",
  //   to:"/notes",
  // },
  // {
  //   id: 5,
  //   style: "bgimage1",
  //   cardimage: booksGif,
  //   cardsvg: booksSvg,
  //   cardheading: "Books",
  //   carddiscription:
  //     'Explore Our Diverse Collection of Books" and be exam ready',
  //   btntext: "Explore Books",
  //   to:"/books",
  // },
  
  
];
export default Data;
